import {createApp} from 'vue'
import App from '../components/Video.vue'

const locale = document.getElementById('video').dataset.locale
const localizedPlay = document.getElementById('video').dataset.localizedplay
const imageUrl = document.getElementById('video').dataset.imageurl
console.log(locale)

createApp(App, {locale, localizedPlay, imageUrl}).mount('#video')
